/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./movePartyTips.vue?vue&type=template&id=78211694&scoped=true&"
import script from "./movePartyTips.vue?vue&type=script&lang=js&"
export * from "./movePartyTips.vue?vue&type=script&lang=js&"
import style0 from "./movePartyTips.vue?vue&type=style&index=0&id=78211694&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78211694",
  null
  
)

export default component.exports